export default {
  icon: 'mdi-file-document-outline',
  name: 'FRI',
  noItems: 'FRI non disponible',
  titles: {
    contractual_commitment: 'Engagement contractuel',
    contract_business: 'Contrat/Affaire',
    contract: 'Contrat',
    business: 'Affaire',
    properties: 'Installations',
    temperature: 'Température',
    property: 'Installation',
    workforce: "Main d'oeuvre",
    service_location: 'Lieu(x) desservi(s)',
    maintenance_plan: 'Plan de maintenance',
    contacts: 'Contact(s)',
    orders: 'Consignes',
    work_order_management: 'Gestion des DI',
  },
  fields: {
    id: 'ID',
    code: "Numéro d'installation",
    name: 'Nom',
    shortname: 'Nom court',
    entity_region: 'Région',
    observation: 'Observations',
    access_information: "Information d'accès",
    door_code: 'Code porte',
    reminder: 'Notes',
    nav_full_id: 'nav_full_id',
    entity_id: 'Code EPEX',
    entity_name: 'EPEX',
    agency_id: 'Code agence',
    agency_name: 'Agence',
    entity: 'Equipe',
    entity_resp: 'Responsable équipe',
    address: 'Adresse',
    location_street_number: 'Numéro',
    location_street_name: 'Rue',
    location_additional_address: '',
    location_building_name: 'Bâtiment',
    location_post_code: 'Code postal',
    location_city: 'Ville',
    location_country: 'Pays',
    mnt_responsible_technician: 'Responsable maintenance',
    mnt_responsible_phone: 'Téléphone',
    mnt_resp_buddy: 'Binôme',
    mnt_resp_buddy_phone: 'Téléphone binôme',
    maintenance_hourly_account: 'Compte horaire de maintenance',
    global_hourly_account: 'Compte horaire global',
    reactive_instructions: 'Technicien',
    dispatcher_instructions: 'Dispatcheur',
    operator_instructions: 'Opérateur',
    m2m_remotemanagement_enabled: 'MyVision',
    gmao_enabled: 'GMAO',
    active_enabled: 'En activité',
    surf_plannable: 'À planifier dans Genesis',
    P3_inventory: 'Inventaire P3',
    tech_inventory: 'Inventaire Technique',
    hot_water: 'ECS',
    inside: 'intérieure',
    technician_affected: 'Technicien affecté',
    fees_prestation_name: 'Prestation des redevances actives',
    autonomy: 'Autonomie',
    altitude: 'Altitude',
    geographical_area: 'Zone géographique',
    cold_power: 'Puissance froide',
    power_hot: 'Puissance chaude',
    power_unit: 'Unité de puissance',
    fluid_coolant: 'Fluide caloporteur',
    fuel_type: 'Type de combustible',
    heating_program: 'Programme de chauffe',

    contractual_commitment: {
      tech_in_charge: 'Technicien en charge',
      request_comment: 'Commentaire dépannage',
      request_unique_phone: "Numéro d'appel de dépannage",
      included_labor_hours: "Nombre d'heures de main d'oeuvre incluses",
      included_interventions: "Nombre d'interventions incluses",
      customer_name: 'Nom du client',
      customer_type: 'Type de client',
      customer_phone: 'Téléphone client',
      supplies_included: 'Liste des consommables inclus',
      amount_supplies_included: 'Montant fourniture',
      intervention_hours: "Heures d'interventions",
      intervention_limit: 'Délai itv',
      intervention_limit_nwh: 'Délai itv',
      request_limit: 'Délai de dépannage',
      request_limit_nwh: 'Délai de dépannage',
      request_included: 'Dép inclus',
      request_included_nwh: 'Dép inclus',
      engagement_type: "Type d'engagement",
      on_call: 'Astreinte',
      contract_reference_name: 'Nom du contrat',
      services_type: 'Prestations liées au contrat',
      contract_reference: 'Numéro du contrat',
      contract_startdate: 'Date engagement contractuel',
      contract_enddate: "Date de fin d'engagement contractuel",
      contract_wh_enabled: 'Contractuel',
      contract_nwh_enabled: 'Contractuel',
      extranetCallingManagement: 'Gestion des appels extranet',
      extranetUnderValidation: 'DI extranet soummise à validation',
      preventive_ordo: 'Ordo prev',
      request_ordo: 'Ordo corr',
      specific_workorder_group: 'Symptomes Spécifiques',
    },
    business: {
      id: 'Code affaire',
      name: "Nom de l'affaire",
    },
    usage: {
      market_type: 'Type de marché',
      planon_enabled: 'Planon',
      gtb_enabled: 'GTC-GTB',
      code: 'Code',
      area_m2: 'Surface (m²)',
      sizing: 'Dimensionnement nombre',
      sizing_lib: 'Dimensionnement',
      sizing_name: 'Dimensionnement type',
      global_hourly_account: 18,
      maintenance_hourly_account: 16,
      purpose: 'Usage',
    },
    energetic_efficiency: {
      maintenance_end_shutdown: "Fin période d'arrêt pour entretien",
      frequency_with_heating: 'Féquence de relève en chauffe : ',
      frequency_without_heating: 'Fréquence de relève hors chauffe : ',
      dhw_temperature_prod: 'Sortie de production : ',
      dhw_temperature_prod_min: 'Min : ',
      dhw_temperature_prod_max: 'Max : ',
      dhw_temperature_tapwater: 'Robinet de puisage : ',
      dhw_temperature_tapwater_min: 'Min : ',
      dhw_temperature_tapwater_max: 'Max : ',
      temperature_interior: 'En chauffage : ',
      temperature_interior_min: 'Min : ',
      temperature_interior_max: 'Max : ',
      temperature_ac: 'En climatisation : ',
      temperature_ac_min: 'Min : ',
      temperature_ac_max: 'Max : ',
      heating_start_datetime: 'Date de début chauffage',
      heating_period: 'Période de chauffe',
      heating_end_datetime: 'Date de fin chauffage',
      reduced_temperature: 'Réduit de nuit',
      reduced_temperature_starttime: 'Début du réduit de nuit',
      reduced_temperature_endtime: 'Fin du réduit de nuit',
    },
    maintenance: {
      tech_in_charge: 'Technicien en charge',
      tech_in_charge_phone: 'Téléphone tech en charge',
      power_hot: 'Puissance chaude',
      installed_power: 'Puissance installé',
      cold_power: 'Puissance froide',
      cold_power_type: 'Type Puissance froide',
      power_unit: 'Unité de puissance',
      fluid_coolant: 'Fluide caloporteur',
      fluid_coolant_type: 'Type de fluide caloporteur',
      heating_program: 'Programme de chauffe',
      observation: 'Observation',
    },
    energy_management: {
      command_authorized: 'Commande combustible autorisée',
      fictitious_enabled: 'Installation fictive',
      altitude: 'Altitude',
      stations: {
        name: 'Station météorologique',
      },
      autonomy: 'Autonomie',
      geographical_area: 'Zone géographique',
      technician_affected: 'Technicien affecté',
      technician_affected_number: 'Technicien affecté numéro',
      technician_affected_firstname: 'Prénom Technicien affecté',
      technician_affected_lastname: 'Nom Technicien affecté',
      fuel_type: 'Type de combustible',
      fees_prestation_name: 'Prestation des redevances actives',
      maintenance_start_shutdown: "Début période d'arrêt pour entretien",
      maintenance_shutdown_period: "Période d'arrêt pour entretien",
    },
    equipment: {
      number: 'Nombre',
      tel_number: 'Numéro de téléphone',
      equipment: 'Matériel',
    },
  },
  readings: {
    no_data: 'Pas de données',
    general: 'Général',
    chauffage: 'Chauffage',
    ecs: 'ECS',
    annee: 'Année',
    qmoyen: 'q moyen (Hors Chauffe)',
    m3j: 'm3/j',
    ecsj: 'ECS / Jour',
    signature: 'Signature énergétique',
    sig_title:
      'Puissance moyenne appelée en kW par température moyenne Extérieure de la période',
    r2: 'r²',
    combustible: 'Combustible',
    vente: 'Vente',
    text: 'T Ext °C',
    pmoyen: 'Pui moy kW',
    cumulated: 'Cumulé',
    table: 'Vue table',
    total: 'Total',
    nodata: 'Aucune relève calculée',
    courbeSup: 'Courbe Sup ?',
    dateSelected: 'Date',
    unit: 'Unité',
    mwhpci: 'MWh (PCI)',
    consommation: 'Consommation',
    production: 'Production',
    titleMid: 'et degrés jours',
    titleEnd: 'cumulés',
    journalSte: 'Journal STE',
    journalTra: 'Journal TRA',
    journalAction: 'Journal Action',
    adict: 'Relèves ADICT',
    dataList: {
      t_moy: 'Température moyenne calculée',
      nc_dj: 'NC MWh (PCI) / DJ',
      nc_dj_obj: 'Objectif technique MWh (PCI) / DJ',
      conso_tot: 'Conso Totale MWh PCI',
      conso_tot_obj: 'Conso Totale théorique MWh PCI',
      conso_eltr_mwhpci: 'Conso élémentaire MWh PCI',
      theo_eltr_mwhpci: 'Conso élémentaire Théorique MWh PCI',
      conso_hecs_mwhpci: 'Conso Hors ECS MWh PCI',
      theo_hecs_mwhpci_djr: 'Conso Hors ECS Théorique MWh PCI',
      ecart_total_global: 'Ecart total',
      ecart_total_pct: 'Ecart total %',
      ecart_cond: 'Ecart de conduite',
      ecart_cond_mwhpci: 'Ecart conduite MWh PCI',
      ecart_cond_pct: 'Ecart conduite %',
      cs: 'CS',
      cs_theo: 'CS Théorique',
      prod_mwh: 'Production MWh',
      prod_unt: 'Production Unité',
      theo_prod_unt: 'Production Théorique Unité',
      prod_idx_unt: 'Production indexée Unité',
      theo_prod_idx_mwh: 'Production Théorique indexée MWh',
      prod_tot: 'Production Totale MWh',
      prod_tot_obj: 'Production Totale Théorique MWh',
      ecart_prod: 'Ecart de production MWh',
      ecart_prod_pct: 'Ecart de production %',
      ecart_q_mwhpci: 'Ecart q MWh PCI',
      qreel_comb: 'q réel Combustible',
      qreel_ener: 'q réel Energie',
      prod_comb: 'Prod ECS unt Combustible',
      ecart_q_ecs_hc: 'Ecart q Hors Chauffe',
      q_ecs_hc: 'q Hors Chauffe',
      q_ecs_hc_obj: 'q théorique Hors Chauffe',
      ecs_j: 'ECS par jour',
      ecs_j_obj: 'ECS Théorique par jour',
      ecs_m3: 'ECS M3',
      nbjour: 'Nombre jours releve',
      nbjour_chauffe: 'Nombre jours chauffe releve',
      dj_reel: 'DJ réels',
      rigueur: 'Rigueur',
      nb_dj_mwh: 'NB Contrat par DJ contrat (MWh)',
    },
    icons: {
      add: 'mdi-plus',
      remove: 'mdi-close-circle',
      disabled: 'mdi-checkbox-blank-outline',
      enabled: 'mdi-checkbox-marked',
      reset: 'mdi-cached',
    },
  },
};
